import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, A11y, Thumbs } from "swiper/modules";

export default {
    name: 'slider',
    component() {
        return {
            initSlider() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        750: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                        },
                    },
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },

            initSliderProduct() {
                const slider = this.$root.querySelector(".swiper");
                const sliderThumbs = this.$root.querySelector(".swiper--thumbs");

                let thumbSlider = new Swiper(sliderThumbs, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: "auto",
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                });

                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation, Thumbs],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                    thumbs: {
                        swiper: thumbSlider,
                        autoScrollOffset: 1,
                    },
                });
            },

            initSliderProductOld() {
                const slider = this.$root.querySelector(".swiper");
                const sliderThumbs = this.$root.querySelector(".swiper--thumbs");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation, Thumbs],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                    breakpoints: {
                        1000: {
                            thumbs: {
                                swiper: sliderThumbs,
                            },
                        },
                    },
                });

                new Swiper(sliderThumbs, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "vertical",
                    loop: false,
                    slidesPerView: "auto",
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    thumbs: {
                        swiper: sliderThumbs,
                    },
                });
            },

            initSliderComplementary() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 2,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        750: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                        },
                    },
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },

            initSliderContinuous(slower) {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: "auto",
                    speed: slower ? 6000 : 3000,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: true,
                    },
                    allowTouchMove: false,
                    disableOnInteraction: true,
                    spaceBetween: 50,
                    breakpoints: {
                        480: {
                            slidesPerView: "auto",
                            spaceBetween: 75,
                        },
                        1000: {
                            slidesPerView: "auto",
                            spaceBetween: 50,
                        },
                        1500: {
                            slidesPerView: "auto",
                            spaceBetween: 100,
                        },
                    },
                    on: {
                        init: (swiper) => {
                            setTimeout(() => {
                                swiper.autoplay.start();
                            }, 1000);
                        },
                    }
                });
            },

            initSliderLogo() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 3,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    speed: 2000,
                    autoplay: {
                        delay: 1,
                        disableOnInteraction: false,
                    },
                    spaceBetween: 50,
                    breakpoints: {
                        480: {
                            spaceBetween: 10,
                            slidesPerView: 4,
                        },
                        767: {
                            spaceBetween: 30,
                            slidesPerView: 5,
                        },
                        1025: {
                            spaceBetween: 50,
                            slidesPerView: 5,
                        },
                        1600: {
                            spaceBetween: 50,
                            slidesPerView: 5,
                        },
                    },
                });
            },


            initSliderReviews(count) {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        480: {
                            slidesPerView: 1,
                            spaceBetween: 10,
                        },
                        750: {
                            slidesPerView: 2,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: count < 3 ? count : 3,
                            spaceBetween: 30,
                        },
                    },
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        // prevEl: this.$root
                        //     .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },

            initSliderTestimonials() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        480: {
                            slidesPerView: 1,
                            spaceBetween: 10,
                        },
                        750: {
                            slidesPerView: 2,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: 1.5,
                            spaceBetween: 30,
                        },
                    },
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        // prevEl: this.$root
                        //     .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },

            initSliderBlogs() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [A11y, Pagination],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 1.05,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        480: {
                            slidesPerView: 1.05,
                            spaceBetween: 10,
                        },
                        750: {
                            slidesPerView: 2.05,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        },
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                });
            },

            initSliderProducts() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [A11y, Pagination],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        750: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                        },
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                });
            },

            initSliderOnlineStores() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        750: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        1000: {
                            slidesPerView: 3,
                            spaceBetween: 50,
                        },
                        1500: {
                            slidesPerView: 3,
                            spaceBetween: 75,
                        },
                    },
                    // navigation: {
                    //     nextEl: this.$root
                    //         .querySelector("[data-slider-btn-next]"),
                    //     // prevEl: this.$root
                    //     //     .querySelector("[data-slider-btn-prev]"),
                    // },
                });
            },

            initSliderUpsell() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1.3,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        1000: {
                            slidesPerView: 1.5,
                        },
                    },
                });
            },
        }
    }
}